function emptyOpenArea() {
    return {
        support: 0,
        blades: 0,
        openWidth: 0,
        openHeight1: 0,
        openHeight2: 0,
        openHeight3: 0,
        freeArea: 0,
        louverAreaSQFT: 0,
        openArea: 0,
    }
}

export function openAreaHandler() {
    let openArea = emptyOpenArea()

    ///////////////////////////////5LS-H/////////////////////////////////

    // methods
    const setSupport = impactLouver => {
        openArea.support = impactLouver.moduleWidth * 39.37007874 > 60 ? 1 : 0
    }
    const setBlades = impactLouver => {
        openArea.blades = (impactLouver.moduleHeight * 39.37007874) / 2 - 1
    }
    const setOpenWidth = impactLouver => {
        const moduleWidthInInches = impactLouver.moduleWidth * 39.37007874
        openArea.openWidth =
            moduleWidthInInches > 60
                ? ((moduleWidthInInches - 2 - 1.5) / 2) * 2
                : moduleWidthInInches - 2
    }
    const setOpenHeight1 = () => {
        openArea.openHeight1 = 0.5
    }
    const setOpenHeight2 = () => {
        openArea.openHeight2 = 1.1875
    }
    const setOpenHeight3 = () => {
        openArea.openHeight3 = 0.125
    }
    const setFreeArea = () => {
        openArea.freeArea =
            (openArea.openWidth * openArea.openHeight1 +
                openArea.openWidth *
                    openArea.openHeight2 *
                    (openArea.blades - 1) +
                openArea.openWidth * openArea.openHeight3) *
            0.006944
    }
    const setLouverAreaSQFT = impactLouver => {
        openArea.louverAreaSQFT =
            impactLouver.moduleWidth *
            impactLouver.moduleHeight *
            1550 *
            0.006944
    }
    const setOpenArea = () => {
        openArea.openArea =
            openArea.louverAreaSQFT == 0
                ? 0
                : openArea.freeArea / openArea.louverAreaSQFT
    }

    ///////////////////////////////5LS-V/////////////////////////////////

    const setSupport5LSV = impactLouver => {
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.support =
            heightInches <= 40
                ? 0
                : heightInches >= 41 && heightInches <= 90
                ? 1
                : heightInches >= 91
                ? 2
                : 0
    }

    const setBlades5LSV = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        openArea.blades = Math.floor((widthInches - 1.8531 - 0.734) / 1.5)
    }

    const setOpenHeight5LSV = impactLouver => {
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.openHeight =
            heightInches > 40
                ? ((heightInches - 2.3459 - 1.5) / 2) * 2
                : heightInches - 2.3459 - 1.5
    }

    const setOpenWidth15LSV = () => {
        openArea.openWidth1 = 0
    }

    const setOpenWidth25LSV = () => {
        openArea.openWidth2 = 0.4011
    }

    const setOpenWidth35LSV = () => {
        openArea.openWidth3 = 0.9047
    }

    const setfreeArea5LSV = () => {
        openArea.freeArea =
            (openArea.openWidth1 * openArea.openHeight +
                openArea.openWidth2 * openArea.openHeight +
                openArea.openWidth3 *
                    openArea.openHeight *
                    (openArea.blades - 1)) *
            0.006944
    }

    const setLouverAreaSQFT5LSV = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.louverAreaSQFT = widthInches * heightInches * 0.006944
    }

    ///////////////////////////////5LS-HV/////////////////////////////////

    const setSupport5LSHV = impactLouver => {
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.support =
            heightInches <= 71
                ? 0
                : heightInches >= 41 && heightInches <= 90
                ? 1
                : heightInches >= 91
                ? 2
                : 0
    }

    const setBlades5LSHV = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        openArea.blades = Math.floor((widthInches - 1.8531 - 0.734) / 0.875) + 1
    }

    const setOpenHeight5LSHV = impactLouver => {
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.openHeight =
            heightInches > 71
                ? ((heightInches - 1.3241 - 4.5 - 1) / 2) * 2
                : heightInches - 1.3241 - 4.5
    }

    const setOpenWidth15LSHV = () => {
        openArea.openWidth1 = 0.1536
    }

    const setOpenWidth25LSHV = () => {
        openArea.openWidth2 = 0.5516
    }

    const setOpenWidth35LSHV = () => {
        openArea.openWidth3 = 0.0959
    }

    const setArea15LSHV = () => {
        openArea.area1 = openArea.openWidth1 * openArea.openHeight
    }

    const setArea25LSHV = () => {
        openArea.area2 =
            openArea.openWidth2 * openArea.openHeight * (openArea.blades - 1)
    }

    const setArea35LSHV = () => {
        openArea.area3 = openArea.openWidth3 * openArea.openHeight
    }

    const setfreeArea5LSHV = () => {
        openArea.freeArea =
            (openArea.area1 + openArea.area2 + openArea.area3) * 0.006944
    }

    const setLouverAreaSQFT5LSHV = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.louverAreaSQFT = widthInches * heightInches * 0.006944
    }

    ///////////////////////////////1.4LS-42/////////////////////////////////

    const setDLO14LS42 = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        openArea.dlo = widthInches - (1.5793 + 1.5793)
    }

    const setSpacesSupport14LS42 = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        openArea.spacesSupport14LS42 =
            Math.ceil(Math.round(widthInches / 16) / 1) * 1
    }

    const setSupport14LS42 = () => {
        openArea.support = openArea.spacesSupport14LS42 + 1
    }

    const setBlades14LS42 = impactLouver => {
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.blades =
            Math.ceil((heightInches - 1.1875 - 13 / 16) / 0.776 / 1) * 1
    }

    const setOpenWidth14LS42 = () => {
        openArea.openWidth =
            openArea.dlo > 16
                ? (openArea.dlo - 0.88 * (openArea.support - 2)) /
                  openArea.spacesSupport14LS42
                : openArea.dlo
    }

    const setOpenHeight1_14LS42 = () => {
        openArea.openHeight1 = 0.4625
    }

    const setOpenHeight2_14LS42 = () => {
        openArea.openHeight2 = 0.3125
    }

    const setOpenHeight3_14LS42 = () => {
        openArea.openHeight3 = 0.776 * Math.sin((42 * Math.PI) / 180) - 0.05
    }

    const setFreeArea14LS42 = () => {
        openArea.freeArea =
            openArea.openWidth *
                openArea.openHeight1 *
                openArea.spacesSupport14LS42 *
                0.0069374444 +
            openArea.openWidth *
                openArea.openHeight2 *
                openArea.spacesSupport14LS42 *
                0.0069374444 +
            openArea.openWidth *
                openArea.openHeight3 *
                openArea.spacesSupport14LS42 *
                (openArea.blades - 1) *
                0.0069374444
    }

    const setLouverAreaSQFT14LS42 = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.louverAreaSQFT = widthInches * heightInches * 0.006945
    }

    ///////////////////////////////1.4LS-60/////////////////////////////////

    const setDLO14LS60 = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        openArea.dlo = widthInches - (1.5793 + 1.5793)
    }

    const setSpacesSupport14LS60 = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        openArea.spacesSupport14LS60 =
            Math.ceil(Math.round(widthInches / 16) / 1) * 1
    }

    const setSupport14LS60 = () => {
        openArea.support = openArea.spacesSupport14LS60 + 1
    }

    const setBlades14LS60 = impactLouver => {
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.blades =
            Math.ceil((heightInches - 1.1875 - 13 / 16) / 0.776 / 1) * 1
    }

    const setOpenWidth14LS60 = () => {
        openArea.openWidth =
            openArea.dlo > 16
                ? (openArea.dlo - 0.88 * (openArea.support - 2)) /
                  openArea.spacesSupport14LS60
                : openArea.dlo
    }

    const setOpenHeight1_14LS60 = () => {
        openArea.openHeight1 = 0.2603
    }

    const setOpenHeight2_14LS60 = () => {
        openArea.openHeight2 = 0.61
    }

    const setOpenHeight3_14LS60 = () => {
        openArea.openHeight3 = 0.776 * Math.sin((60 * Math.PI) / 180) - 0.05
    }

    const setFreeArea14LS60 = () => {
        openArea.freeArea =
            openArea.openWidth *
                openArea.openHeight1 *
                openArea.spacesSupport14LS60 *
                0.0069374444 +
            openArea.openWidth *
                openArea.openHeight2 *
                openArea.spacesSupport14LS60 *
                0.0069374444 +
            openArea.openWidth *
                openArea.openHeight3 *
                openArea.spacesSupport14LS60 *
                (openArea.blades - 1) *
                0.0069374444
    }

    const setLouverAreaSQFT14LS60 = impactLouver => {
        const widthInches = impactLouver.width / impactLouver.hModules
        const heightInches = impactLouver.height / impactLouver.vModules
        openArea.louverAreaSQFT = widthInches * heightInches * 0.006945
    }

    const calculateOpenArea = items => {
        for (const impactLouver of items) {
            if (
                impactLouver.model === '5LS-H' ||
                impactLouver.model === '3LS-V'
            ) {
                setSupport(impactLouver)
                setBlades(impactLouver)
                setOpenWidth(impactLouver)
                setOpenHeight1()
                setOpenHeight2()
                setOpenHeight3()
                setFreeArea()
                setLouverAreaSQFT(impactLouver)
                setOpenArea()
            } else if (impactLouver.model === '5LS-V') {
                setSupport5LSV(impactLouver)
                setBlades5LSV(impactLouver)
                setOpenHeight5LSV(impactLouver)
                setOpenWidth15LSV()
                setOpenWidth25LSV()
                setOpenWidth35LSV()
                setfreeArea5LSV()
                setLouverAreaSQFT5LSV(impactLouver)
                setOpenArea()
            } else if (impactLouver.model === '5LS-HV') {
                setSupport5LSHV(impactLouver)
                setBlades5LSHV(impactLouver)
                setOpenHeight5LSHV(impactLouver)
                setOpenWidth15LSHV()
                setOpenWidth25LSHV()
                setOpenWidth35LSHV()
                setArea15LSHV()
                setArea25LSHV()
                setArea35LSHV()
                setfreeArea5LSHV()
                setLouverAreaSQFT5LSHV(impactLouver)
                setOpenArea()
            } else if (
                impactLouver.model === '1.4LS-42' ||
                impactLouver.model === '1.4LS-42-HP'
            ) {
                setDLO14LS42(impactLouver)
                setSpacesSupport14LS42(impactLouver)
                setSupport14LS42(impactLouver)
                setBlades14LS42(impactLouver)
                setOpenWidth14LS42(impactLouver)
                setOpenHeight1_14LS42()
                setOpenHeight2_14LS42()
                setOpenHeight3_14LS42()
                setFreeArea14LS42()
                setLouverAreaSQFT14LS42(impactLouver)
                setOpenArea()
            } else if (impactLouver.model === '1.4LS-60') {
                setDLO14LS60(impactLouver)
                setSpacesSupport14LS60(impactLouver)
                setSupport14LS60(impactLouver)
                setBlades14LS60(impactLouver)
                setOpenWidth14LS60(impactLouver)
                setOpenHeight1_14LS60()
                setOpenHeight2_14LS60()
                setOpenHeight3_14LS60()
                setFreeArea14LS60()
                setLouverAreaSQFT14LS60(impactLouver)
                setOpenArea()
            }
            impactLouver.openArea = { openArea: openArea.openArea }
            openArea = emptyOpenArea()
        }
        return items
    }

    return {
        calculateOpenArea,
    }
}
